import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Typography from '@eig-builder/core-ui/Typography'

const StyledLinkText = styled(Typography)`
  display: inline-flex;
  font-size: 14px !important;
  text-decoration: none !important;
`

const LinkText = ({ children, ...restProps }) => (
  <StyledLinkText variant='link2' {...restProps}>
    {children}
  </StyledLinkText>
)

LinkText.propTypes = {
  children: PropTypes.any.isRequired
}

export default LinkText
